import { useEffect, useRef } from "react";

// Subtle premium cursor: a small dot + a delayed ring.
// Ring grows on interactive elements (a, button, [data-cursor="hover"]).
export default function CustomCursor() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const state = useRef({
    x: 0,
    y: 0,
    tx: 0,
    ty: 0,
  });

  useEffect(() => {
    const isCoarse =
      typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(hover: none), (pointer: coarse)").matches;
    if (isCoarse) return;

    const dot = dotRef.current;
    const ring = ringRef.current;
    if (!dot || !ring) return;

    const onMove = (e) => {
      state.current.x = e.clientX;
      state.current.y = e.clientY;
      dot.style.transform = `translate(${e.clientX}px, ${e.clientY}px) translate(-50%, -50%)`;
    };

    const onOver = (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      const interactive = t.closest("a, button, [data-cursor='hover'], [role='button']");
      if (interactive) {
        ring.classList.add("hover");
      } else {
        ring.classList.remove("hover");
      }
    };

    let rafId;
    const loop = () => {
      state.current.tx += (state.current.x - state.current.tx) * 0.15;
      state.current.ty += (state.current.y - state.current.ty) * 0.15;
      ring.style.transform = `translate(${state.current.tx}px, ${state.current.ty}px) translate(-50%, -50%)`;
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);

    window.addEventListener("mousemove", onMove, { passive: true });
    window.addEventListener("mouseover", onOver, { passive: true });

    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", onOver);
      cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <>
      <div ref={ringRef} className="cursor-ring" aria-hidden />
      <div ref={dotRef} className="cursor-dot" aria-hidden />
    </>
  );
}
